import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  getColumns,
  getData,
  getGeneratedOnDateTime,
  getIsLoading,
} from "../redux/selectors/DespatchImpcToImpcSelectors";
// eslint-disable-next-line import/no-named-as-default
import Report from "../../../../common/components/Report";
import ReportDefinitions from "../../../../../common/config/ReportDefinitions";

export const DespatchImpcToImpcPerformanceContainer = (props) => (
  <Report
    reportId={ReportDefinitions.IMPC_TO_IMPC_DESPATCH_PERFORMANCE.id}
    generatedOnDateTime={props.generatedDateTime}
    isLoading={props.isLoading}
    data={props.data}
    columns={props.columns}
    defaultSorted={[{ id: "originImpc", desc: false }]}
    className="impcToImpcDespatchPerformanceReport"
  />
);

function mapStateToProps(state, props) {
  return {
    data: getData(state, props),
    columns: getColumns(state, props),
    generatedDateTime: getGeneratedOnDateTime(state, props),
    isLoading: getIsLoading(state, props),
  };
}

DespatchImpcToImpcPerformanceContainer.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  columns: PropTypes.arrayOf(PropTypes.object),
  generatedDateTime: PropTypes.string,
  isLoading: PropTypes.bool,
};

export default connect(mapStateToProps)(DespatchImpcToImpcPerformanceContainer);
